import { Component, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import * as jspreadsheet from 'jspreadsheet-ce';
import { ProductionBoardService } from 'src/app/services/production-board/production-board.service';

@Component({
	selector: 'app-week-production',
	templateUrl: './week-production.component.html',
	styleUrls: ['./week-production.component.scss'],
})
export class WeekProductionComponent implements AfterViewInit {
	@ViewChild('sheet', { static: true }) sheet: ElementRef;
	// private campaingUpdate: UsersData = new UsersData('',0,0,0,0,0,0,0,0,0,0,0,0,0);
	constructor(private productionBoard: ProductionBoardService) {}

	ngAfterViewInit(): void {
		var promise = Promise.resolve(this.productionBoard.getUsersData());
		promise.then((value) => {
			var tableWeek = jspreadsheet(this.sheet.nativeElement, {
				data: value.body,
				csvHeaders: true,
				search: true,
				// pagination:100,
				tableOverflow: true,
				// freezeColumns: 3,
				tableWidth: '1100px',
				// tableHeight: '1100px',
				columns: [
					{
						type: 'text',
						title: 'User',
						width: 80,
					},
					{
						type: 'numeric',
						title: 'Leads',
						width: 80,
					},
					{
						type: 'numeric',
						title: 'Replace',
						width: 80,
					},
					{
						type: 'numeric',
						title: 'Leads',
						width: 80,
					},
					{
						type: 'numeric',
						title: 'Replace',
						width: 80,
					},
					{
						type: 'numeric',
						title: 'Leads',
						width: 80,
					},
					{
						type: 'numeric',
						title: 'Replace',
						width: 80,
					},
					{
						type: 'numeric',
						title: 'Leads',
						width: 80,
					},
					{
						type: 'numeric',
						title: 'Replace',
						width: 80,
					},
					{
						type: 'numeric',
						title: 'Leads',
						width: 80,
					},
					{
						type: 'numeric',
						title: 'Replace',
						width: 80,
					},
					{
						type: 'numeric',
						title: 'Leads',
						width: 80,
					},
					{
						type: 'numeric',
						title: 'Replace',
						width: 80,
					},
					{
						type: 'numeric',
						title: 'Total',
						width: 80,
					},
				],
				nestedHeaders: [
					[
						{
							title: 'User Name',
							colspan: 1,
						},
						{
							title: 'Monday',
							colspan: 2,
						},
						{
							title: 'Tuesday',
							colspan: 2,
						},
						{
							title: 'Wednesday',
							colspan: 2,
						},
						{
							title: 'Thursday',
							colspan: 2,
						},
						{
							title: 'Friday',
							colspan: 2,
						},
						{
							title: 'Totals',
							colspan: 3,
						},
					],
				],
				footers: [
					[
						'N/A',
						'=SUM(B1:B300)',
						'=SUM(C1:C300)',
						'=SUM(D1:D300)',
						'=SUM(E1:E300)',
						'=SUM(F1:F300)',
						'=SUM(G1:G300)',
						'=SUM(H1:H300)',
						'=SUM(I1:I300)',
						'=SUM(J1:J300)',
						'=SUM(K1:K300)',
						'=SUM(L1:L300)',
						'=SUM(M1:M300)',
						'=SUM(N1:N300)',
						'=SUM(O1:O300)',
						'=SUM(P1:P300)',
					],
				],

				updateTable: function (
					instance,
					cell,
					col,
					row,
					val,
					label,
					cellName,
				) {},
			});
		});
	}
}
